import { useEffect, useState } from 'react'
import { doc, onSnapshot, setDoc } from 'firebase/firestore'
import { db } from '@/firebase'
import {
  AuthConfigDoc,
  emptyAuthConfigDoc,
  FBPATHS,
  toAuthConfigDoc
} from '@smorgrav/hundehall_shared'

/**
 * Live view of the platform-global `config/auth` policy. Read access is granted
 * to everyone by the Firestore rules; writes are root-only (saveAuthConfig).
 */
const useAuthConfig = () => {
  const [config, setConfig] = useState<AuthConfigDoc>(emptyAuthConfigDoc())
  const [loading, setLoading] = useState(true)
  const [exists, setExists] = useState(false)

  useEffect(() => {
    const unsub = onSnapshot(
      doc(db, FBPATHS.config.auth),
      (snap) => {
        setExists(snap.exists())
        setConfig(toAuthConfigDoc(snap.data()))
        setLoading(false)
      },
      (err) => {
        console.error('Failed to read config/auth', err)
        setLoading(false)
      }
    )
    return () => unsub()
  }, [])

  return { config, loading, exists }
}

// Full-document overwrite — the editor always holds a complete, sanitized doc.
const saveAuthConfig = async (config: AuthConfigDoc): Promise<void> => {
  await setDoc(doc(db, FBPATHS.config.auth), config)
}

export { useAuthConfig, saveAuthConfig }
